<script>
import Layout from "@/layouts/main";
import Navbar from "@/components/navbar";
// switcher는 색상모드 바꾸는 부분임
//import Switcher from "@/components/switcher";
import { VueTyper } from "vue-typer"; // 타이핑 글자 나오는거
import appConfig from "@/app.config";
import axios from 'axios';
import AOS from 'aos';
import "aos/dist/aos.css";

export default {
  components: {
    Layout,
    Navbar,
    //Switcher,
    "vue-typer": VueTyper,
  },
  data() {
    return {
      baseInfo: {},
      currentSeroIndex: 0,
      seroImages: [
        'https://image.yes24.com/goods/92325450/XL',
        'images/_decen/cat.png',
        'images/_decen/woman1.png',
        'images/_decen/woman2.png',
        'images/_decen/woman3.png',
        'images/_decen/woman4.png',
      ],
      imageUrl: "images/work/bg-portfolio.jpg",
      gradientColors: [
        "rgba(0, 0, 0, 0.1)",
        "rgba(20, 20, 20, 0.25)",
        "rgba(20, 20, 20, 0.5)",
        "rgba(20, 20, 20, 0.8)",
        "rgba(20, 20, 20, 1)"
      ],
      latestData: {
        latest1: [],
        latest2: [],
        latest3: [],
        latest4: [],
        latest5: [],
      },
      caseList: [
      {
          image: 'images/_decen/sample1.png',
          title: '성명&논평글 테스트샘플 1 활동글 테스트샘플 1',
          variant: 'success',
          type: '성명&논평',
        },
        {
          image: 'images/_decen/sample1.png',
          title: '성명&논평글 테스트샘플33 활동글 테스트샘플 1',
          variant: 'success',
          type: '성명&논평',
        },
        {
          image: 'images/_decen/sample4.png',
          title: '공지사항 테스트샘플 1',
          variant: 'info',
          type: '공지사항',
        },
        {
          image: 'images/_decen/sample2.png',
          title: '공지사항 테스트샘플 2',
          variant: 'info',
          type: '공지사항',
        },
        {
          image: 'images/_decen/sample5.png',
          title: '성명&논평글 테스트샘플 2',
          variant: 'success',
          type: '성명&논평',
        },
        {
          image: 'images/_decen/sample6.png',
          title: '공지사항 테스트샘플 3',
          variant: 'info',
          type: '공지사항',
        },
        {
          image: 'images/_decen/sample7.png',
          title: '알통글 테스트샘플 4',
          variant: 'info',
          type: '공지사항',
        },
        {
          image: 'images/_decen/sample8.png',
          title: '성명&논평글 테스트샘플 3',
          variant: 'success',
          type: '성명&논평',
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: '대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터는 성매매 피해여성의 인권을 보호하고 지원하는 대구여성단체입니다.'
        },
        {
          property: 'og:title',
          content: '대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터는 성매매 피해여성의 인권을 보호하고 지원하는 대구여성단체입니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터는 성매매 피해여성의 인권을 보호하고 지원하는 대구여성단체입니다.'
        }
      ]
    }
  },
  mounted() { 
    // AOS 초기화
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  },
  destroyed() {
  },
  created() {
    this.getWebSiteInfoBase()
    this.getLatestInfo()
  },
  computed: {
    // title 이미지
    backgroundStyle() {
      const gradient = `linear-gradient(to top, ${this.gradientColors.map((color, index) => `${color} ${index * 25}%`).join(', ')})`;
      return {
        backgroundImage: `${gradient}, url('${this.imageUrl}')`
      };
    },
    // 현재 이미지의 경로 계산
    currentSeroImg() {
      return this.seroImages[this.currentSeroIndex];
    },
  },
  methods: {
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    nextSeroImg() {
      //this.$router.push({ path: '/jy/5/w'})
      // 현재 이미지 인덱스를 증가시킴
      this.currentSeroIndex++;
      // 이미지 인덱스가 이미지 배열의 길이를 초과하면 처음 이미지로 돌아감
      if (this.currentSeroIndex >= this.seroImages.length) {
        this.currentSeroIndex = 0;
      }
    },
    newTab(val) {
      var win = window.open(val, '_blank');
      win.focus();
    },
    // 게시판 정보 받아오자
    async getLatestInfo() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/index_get_last_info',
          data: {
            "work": 'index',
            "latest1_num": 4, // 최근 소식
            "latest2_num": 6, // 활동소식
            "latest3_num": 4, // 알통
            "latest4_num": 5, // 공지사항
            "latest5_num": 4, // 성명&논평
          },
        })
        .then((res) => {
          if (res.data) {
            if (res.data.status =='success') {
              if (res.data.latestData) {
                if (res.data.latestData.latest1) {
                  this.latestData.latest1 = res.data.latestData.latest1
                }
                if (res.data.latestData.latest2) {
                  this.latestData.latest2 = res.data.latestData.latest2
                }
                if (res.data.latestData.latest3) {
                  this.latestData.latest3 = res.data.latestData.latest3
                }
                if (res.data.latestData.latest4) {
                  this.latestData.latest4 = res.data.latestData.latest4
                }
                if (res.data.latestData.latest5) {
                  this.latestData.latest5 = res.data.latestData.latest5
                }
              }
              /*
              if (res.data.thisBoard) {
                this.thisBoard = res.data.thisBoard
              }
              */
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': '정보반환 실패', text: res.data})
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
          if (error.code=='ERR_NETWORK') {
            console.log(error.message)
            this.$notify({ type: 'error', duration: 3000, 'title': '서버오류', text: error.message})
          }
        })
        .finally(()=> {
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    thumnailLatest(val1, val2) {
      return `${appConfig.fileserver}/${val1}/${val2}/thum.jpg`;
    },
  },
};
</script>

<template>
  <Layout>
    <Navbar :nav-light="true" />

    <section class="bg-half-220 d-table w-100 navwave">
      <div class="animation-effect-1">
        <i class="mdi mdi-ufo-outline effect-icon-1 text-white"></i>
      </div>
      <div class="animation-effect-2">
        <i class="mdi mdi-pinwheel-outline effect-icon-1 text-warning"></i>
      </div>
      <div class="animation-effect-3">
        <i class="mdi mdi-airplane effect-icon-3 text-white"></i>
      </div>
      <div class="animation-effect-4">
        <i class="mdi mdi-image-filter-vintage effect-icon-2 text-warning"></i>
      </div>
      <div class="animation-effect-5">
        <i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i>
      </div>
      <div class="animation-effect-6">
        <i class="mdi mdi-star-four-points effect-icon-1 text-white"></i>
      </div>
      <div class="animation-effect-7">
        <i class="mdi mdi-airballoon effect-icon-2 text-danger"></i>
      </div>
      <div class="bread-overlay opacity-5"></div>
      <div class="container">
        <div class="row mt-2 mt-md-4">
          <div class="col-12">
            <div class="title-heading ">
              <h4 v-if="baseInfo.index_topmessage_title && baseInfo.index_topmessage" class="display-6 mb-4 font-weight-bold text-white title-dark main-vuetyper">
                <span class="display-7">
                  {{ baseInfo.index_topmessage_title }}<br />
                </span>
                <vue-typer
                  :text="baseInfo.index_topmessage" 
                  caret-animation='smooth'
                  :erase-delay=700
                  initial-action='erasing'
                ></vue-typer>
              </h4>
              <div class="mt-4 pt-2">
                <router-link :to="`/jy/5/w`">
                  <span class="btn btn-info cursor-pointers">비밀보장 상담하기</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-light">
      <div class="container">

        <div class="row features-absolute rounded bg-white shadow">

          <!-- 리본 -->
          <router-link :to="`/jy/1`">
            <div @click="router.push('/jy/1')" class="ribbon ribbon-left ribbon-primary overflow-hidden">
              <span class="text-center d-block shadow small h6 cursor-pointers">
                활동소식
              </span>
            </div>
          </router-link>

          <div v-for="(item, index) in latestData.latest2" :key="index" class="col-lg-4 col-md-6 mt-2 mb-3 pt-2">
            <router-link :to="`/jy/${item.table_idx}/r/${item.write_idx}`">
              <div data-aos="fade-up" class="card blog rounded border-0 shadow">
                <div class="work-container work-modern position-relative position-relative d-block overflow-hidden">
                  <!-- 썸네일 없으면 -->
                  <div v-if="item.is_thum==0" class="gallery-noimg vertical-center text-center border-bottom p-2">
                    <div class="text-center"><i class="mdi mdi-text-box noimg"></i></div>
                    <div class="text-dark h5 text-overflow300 text-center">{{ item.subject }}</div>
                  </div>
                  <!-- 썸네일 있음 -->
                  <div v-else class="gallery-container text-center border-bottom">
                    <img :src="thumnailLatest(item.table_idx, item.write_idx)" class="img-fluid work-image" alt="" loading="lazy">
                  </div>
                </div>
                <div class="card-body p-2 content">
                  <div :class="`badge badge-soft-${item.board_variant} mb-1`">{{item.board_name}}</div>
                  <div class="text-bold text-overflow300">
                    <span class="font-size-14 text-dark">{{ item.subject }}</span>
                  </div>
                  <div class="d-flex align-items-right justify-content-between mt-2 mb-2">
                    <div>
                      <div class="font-size-10">
                        <span class="mr-2">
                          <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                          <b class="text-muted">{{ item.insert_time }}</b>
                        </span>
                        <span class="text-secondary comments">
                          <i class="mdi mdi-eye text-info mr-1"></i>
                          <b>{{ item.hit }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 최근 소식 -->
    <!--
    <section class="section">
      <div class="container">
        <div class="row features-absolute rounded bg-white shadow">
          <div class="col-12 text-center">
            <div class="section-title pb-2">
              <span class="badge badge-pill badge-soft-primary mb-2">
                <i class="mdi mdi-flower-tulip-outline h3"></i>
              </span>
              <h4 class="title">
                센터의 다양한 <span class="text-primary font-weight-bold">활동소식</span>입니다.
              </h4>
            </div>
            <div class="">
              <router-link to="/jy/1">
                <span class="btn btn-soft-primary my-2">더보기..</span>
              </router-link>
            </div>
          </div>
        </div>
        <div data-aos="fade-up" class="row">
          <div class="col-lg-12">
            <div class="">
              <div class="row">

                <div class="ribbon ribbon-left ribbon-primary overflow-hidden">
                  <span class="text-center d-block shadow small h6">
                    최근 소식
                  </span>
                </div>

                <div class="col-lg-12 col-md-12 my-2">
                  <div v-if="latestData.latest1" class="row">
                    <div v-for="(item, index) in latestData.latest1" :key="index" class="col-md-6 col-12">
                      
                      <router-link :to="`/jy/${item.table_idx}/r/${item.write_idx}`">
                        <div class="media features cursor-pointers p-4">
                          <div class="work-container work-modern position-relative d-block overflow-hidden">

                            <div v-if="item.is_thum==0" class="mr-2">
                              <div class="bg-soft-primary text-center rounded-circle avatar avatar-medium d-block mx-auto">
                                <i class="mdi mdi-flower-tulip-outline indexlatest-noimg text-primary"></i>
                              </div>
                            </div>
                            <div v-else class="mr-2">
                              <img :src="thumnailLatest(item.table_idx, item.write_idx)" class="avatar avatar-medium rounded shadow d-block mx-auto" alt="">
                            </div>
                          </div>
                          
                          <div class="media-body">
                            <div :class="`badge badge-soft-${item.board_variant} mb-1`">{{item.board_name}}</div>
                            <div class="text-bold font-size-14 text-dark">{{ item.subject }}</div>
                            <div class="font-size-10 mt-2">
                              <span class="mr-2">
                                <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                                <b class="text-muted">{{ item.insert_time }}</b>
                              </span>
                              <span class="text-secondary comments">
                                <i class="mdi mdi-eye text-info mr-1"></i>
                                <b>{{ item.hit }}</b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center">
                      <i class="mdi mdi-loading mdi-spin text-primary"></i>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    -->

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title pb-2">
              <span class="badge badge-pill badge-soft-danger mb-2">
                <i class="mdi mdi-book-open-page-variant-outline h3"></i>
              </span>
              <h4 class="title">
                센터 정기 소식지 <span class="text-danger font-weight-bold">알통</span>입니다.
              </h4>
            </div>
            <div class="">
              <router-link to="/jy/4">
                <span class="btn btn-soft-danger my-2">더보기..</span>
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div data-aos-anchor-placement="top-center" v-for="(item, index) in latestData.latest3" :key="index" class="col-lg-3 col-md-6 mt-4 pt-2">
            <router-link :to="`/jy/${item.table_idx}/r/${item.write_idx}`">
              <div data-aos="fade-up" class="card blog rounded border-0 shadow">
                <div class="work-container work-modern position-relative position-relative d-block overflow-hidden">
                  <!-- 썸네일 없으면 -->
                  <div v-if="item.is_thum==0" class="gallery-noimg vertical-center text-center border-bottom p-2">
                    <div class="text-center"><i class="mdi mdi-text-box noimg"></i></div>
                    <div class="text-dark h5 text-overflow300 text-center">{{ item.subject }}</div>
                  </div>
                  <!-- 썸네일 있음 -->
                  <div v-else class="gallery-container text-center border-bottom">
                    <img :src="thumnailLatest(item.table_idx, item.write_idx)" class="img-fluid work-image" alt="" loading="lazy">
                  </div>
                </div>
                
                <div class="card-body p-2 content">
                  <div :class="`badge badge-soft-${item.board_variant} mb-1`">{{item.board_name}}</div>
                  <div class="text-bold text-overflow300">
                    <span class="font-size-14 text-dark">{{ item.subject }}</span>
                  </div>
                  <div class="d-flex align-items-right justify-content-between mt-2 mb-2">
                    <div>
                      <div class="font-size-10">
                        <span class="mr-2">
                          <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                          <b class="text-muted">{{ item.insert_time }}</b>
                        </span>
                        <span class="text-secondary comments">
                          <i class="mdi mdi-eye text-info mr-1"></i>
                          <b>{{ item.hit }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-light">
      <div class="container">
        <div class="row">

          <!-- 공지사항 나오게할 부분 -->
          <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 mb-4">
            <div class="row justify-content-center">
              <div class="col-12 text-center">
                <div class="section-title pb-2">
                  <span class="badge badge-pill badge-soft-info mb-2">
                    <i class="mdi mdi-book-open-page-variant-outline h3"></i>
                  </span>
                  <h5 class="title">
                    <div class="text-info">공지사항</div>
                  </h5>
                </div>
                <div class="">
                  <router-link to="/jy/2">
                    <span class="btn btn-soft-info my-2">더보기..</span>
                  </router-link>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" class="row projects-wrapper">
              <div v-for="(item, index) in latestData.latest4" :key="index" class="col-md-12 col-12 mt-4">
                <router-link :to="`/jy/${item.table_idx}/r/${item.write_idx}`">
                  <div class="media key-feature cursor-pointers py-2">
                    <div class="work-container work-modern position-relative d-block overflow-hidden">
                      <!-- 썸네일 없으면 -->
                      <div v-if="item.is_thum==0" class="mr-2">
                        <div class="bg-soft-primary text-center rounded-circle avatar avatar-medium d-block mx-auto">
                          <i class="mdi mdi-flower-tulip-outline indexlatest-noimg text-primary"></i>
                        </div>
                      </div>
                      <!-- 썸네일 있음 -->
                      <div v-else class="mr-2">
                        <img :src="thumnailLatest(item.table_idx, item.write_idx)" class="avatar avatar-medium rounded shadow d-block mx-auto" alt="" loading="lazy">
                      </div>
                    </div>
                    
                    <div class="media-body">
                      <div :class="`badge badge-soft-${item.board_variant} mb-1`">{{item.board_name}}</div>
                      <div class="text-bold font-size-14 text-dark">{{ item.subject }}</div>
                      <div class="font-size-10 mt-2">
                        <span class="mr-2">
                          <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                          <b class="text-muted">{{ item.insert_time }}</b>
                        </span>
                        <span class="text-secondary comments">
                          <i class="mdi mdi-eye text-info mr-1"></i>
                          <b>{{ item.hit }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- 성명&논평 나오게할 부분 -->
          <div class="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="row justify-content-center">
              <div class="col-12 text-center">
                <div class="section-title pb-2">
                  <span class="badge badge-pill badge-soft-success mb-2">
                    <i class="mdi mdi-book-open-page-variant-outline h3"></i>
                  </span>
                  <h5 class="title">
                    <div class="text-success">성명&논평</div>
                  </h5>
                </div>
                <div class="">
                  <router-link to="/jy/3">
                    <span class="btn btn-soft-success my-2">더보기..</span>
                  </router-link>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" class="row projects-wrapper">
              <div v-for="(item, index) in latestData.latest5" :key="index" class="col-lg-6 col-md-6 mt-4 pt-2">
                <router-link :to="`/jy/${item.table_idx}/r/${item.write_idx}`">
                  <div class="card blog rounded border-0 shadow">
                    <div class="work-container work-modern position-relative position-relative d-block overflow-hidden">
                      <!-- 썸네일 없으면 -->
                      <div v-if="item.is_thum==0" class="gallery-noimg vertical-center text-center border-bottom p-2">
                        <div class="text-center"><i class="mdi mdi-text-box noimg"></i></div>
                        <div class="text-dark h5 text-overflow300 text-center">{{ item.subject }}</div>
                      </div>
                      <!-- 썸네일 있음 -->
                      <div v-else class="gallery-container text-center border-bottom">
                        <img :src="thumnailLatest(item.table_idx, item.write_idx)" class="img-fluid work-image" alt="">
                      </div>
                    </div>
                    
                    <div class="card-body p-2 content">
                      <div :class="`badge badge-soft-${item.board_variant} mb-1`">{{item.board_name}}</div>
                      <div class="text-bold text-overflow300">
                        <span class="font-size-14 text-dark">{{ item.subject }}</span>
                      </div>
                      <div class="d-flex align-items-right justify-content-between mt-2 mb-2">
                        <div>
                          <div class="font-size-10">
                            <span class="mr-2">
                              <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                              <b class="text-muted">{{ item.insert_time }}</b>
                            </span>
                            <span class="text-secondary comments">
                              <i class="mdi mdi-eye text-info mr-1"></i>
                              <b>{{ item.hit }}</b>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container ">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <div class="title mb-4">
                <div class="h5">대구여성인권센터 SNS 바로가기</div>
              </div>
              
              <div class="container">
                <div data-aos="fade-up" class="row">
                  <div v-if="this.baseInfo.sns3" class="col-lg-3 col-md-6 col-12 mb-2">
                    <a @click="newTab(baseInfo.sns3)" href="javascript:void(0)">
                      <div class="media key-feature align-items-center p-3 rounded shadow bg-soft-warning">
                        <img src="images/client/kakao.svg" class="avatar avatar-ex-sm" alt="" loading="lazy">
                        <div class="media-body text-right ml-3">
                          <h5 class="mb-0 text-secondary text-bold">카카오채널</h5>
                          <p class="font-size-13 text-muted mb-0">바로가기</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div v-if="this.baseInfo.sns1" class="col-lg-3 col-md-6 col-12 mb-2 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <a @click="newTab(baseInfo.sns1)" href="javascript:void(0)">
                      <div class="media key-feature align-items-center p-3 rounded shadow bg-soft-blue">
                        <img src="images/client/facebook.svg" class="avatar avatar-ex-sm" alt="" loading="lazy">
                        <div class="media-body text-right ml-3">
                          <h5 class="mb-0 text-secondary text-bold">페이스북</h5>
                          <p class="font-size-13 text-muted mb-0">바로가기</p> 
                        </div>
                      </div>
                    </a>
                  </div>
                  <div v-if="this.baseInfo.sns2" class="col-lg-3 col-md-6 col-12 mb-2 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <a @click="newTab(baseInfo.sns2)" href="javascript:void(0)">
                      <div class="media key-feature align-items-center p-3 rounded shadow bg-soft-danger">
                        <img src="images/client/instagram.svg" class="avatar avatar-ex-sm" alt="" loading="lazy">
                        <div class="media-body text-right ml-3">
                          <h5 class="mb-0 text-secondary text-bold">인스타그램</h5>
                          <p class="font-size-13 text-muted mb-0">바로가기</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div v-if="this.baseInfo.sns4" class="col-lg-3 col-md-6 col-12 mb-2 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <a @click="newTab(baseInfo.sns4)" href="javascript:void(0)">
                      <div class="media key-feature align-items-center p-3 rounded shadow bg-soft-dark">
                        <img src="images/client/twitter.svg" class="avatar avatar-ex-sm" alt="" loading="lazy">
                        <div class="media-body text-right ml-3">
                          <h5 class="mb-0 text-secondary text-bold">X (트위터)</h5>
                          <p class="font-size-13 text-muted mb-0">바로가기</p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


  </Layout>
</template>

<style>
.modal-content {
  background-color: transparent;
}
</style>